import React from "react";
import { Accordion, Badge, Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconCalendar, IconClock } from "@tabler/icons-react";
import type { Language, ShiftDto } from "../types";
import type { Texts } from "../texts";
import { formatDate } from "../helpers";

type Props = {
    shifts: ShiftDto[];
    language: Language;
    t: Texts;
};

export default function ShiftsSection({ shifts, language, t }: Props) {
    if (shifts.length === 0) return null;

    return (
        <Accordion.Item value="shifts">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconClock size={18} />
                    </ThemeIcon>
                }
            >
                {t.shifts}
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="sm">
                    {shifts.map((s) => (
                        <Paper key={s.shiftId} withBorder p="sm" radius="md">
                            <Group justify="space-between" align="flex-start">
                                <div>
                                    <Text fw={600}>{s.title}</Text>

                                    <Group gap="xs" mt={4}>
                                        <IconCalendar size={16} />
                                        <Text size="sm">
                                            {formatDate(s.date, language)} · {s.start}
                                            {s.endsOneHourAfterPlay
                                                ? (language === "da"
                                                    ? " - (slutter 1 time efter sidste kamp)"
                                                    : " - (ends 1 hour after last match)")
                                                : `–${s.end}`}
                                        </Text>
                                    </Group>

                                    {s.functionName && (
                                        <Text size="xs" c="dimmed">
                                            {s.functionName}
                                        </Text>
                                    )}
                                </div>

                                {s.status && (
                                    <Badge color="red" variant="light">
                                        {s.status}
                                    </Badge>
                                )}
                            </Group>
                        </Paper>
                    ))}
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}